import React, { useRef, useState } from 'react';
import { Calendar3 } from 'react-bootstrap-icons';
import {
  getMilestoneDateInputType,
  toMilestoneCellDisplayValue
} from './milestoneDateHelpers';
import MilestoneDateModal from './MilestoneDateModal';
import './inputs/SheetInputs.scss';

/**
 * Sheet cell for {{delivery | start}} (and sibling milestone leaves).
 * Shows the start date; click opens a popup to edit the full milestone group.
 */
const MilestoneDateCell = ({
  config,
  milestone,
  buyerEmail,
  appChoices,
  disabled = false,
  textAlign = 'left',
  title,
  inline = false,
  onChange
}) => {
  const [open, setOpen] = useState(false);
  const ignoreFocusRef = useRef(false);
  const inputType = getMilestoneDateInputType(config);
  const displayValue = toMilestoneCellDisplayValue(milestone, config);
  const isEmpty = !displayValue;
  const hint = config?.name ? `${config.name} date` : 'Milestone date';
  const tooltip = title ? `${hint} (${title})` : hint;
  const wrapperClass = [
    'dochub-variable-cell',
    inline ? 'is-inline' : '',
    'is-milestone'
  ]
    .filter(Boolean)
    .join(' ');

  const closeModal = () => {
    // Closing restores focus to the trigger; ignore that focus so the modal does not reopen.
    ignoreFocusRef.current = true;
    setOpen(false);
    window.setTimeout(() => {
      ignoreFocusRef.current = false;
    }, 150);
  };

  const openModal = e => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (disabled || ignoreFocusRef.current || open) return;
    setOpen(true);
  };

  return (
    <div className={wrapperClass}>
      <div
        className={[
          'dochub-sheet-input-wrap',
          inline ? 'is-inline' : '',
          isEmpty ? 'is-date-empty' : '',
          'is-milestone-trigger'
        ]
          .filter(Boolean)
          .join(' ')}
      >
        {isEmpty && (
          <div
            className="dochub-sheet-hint"
            style={{
              textAlign,
              justifyContent: textAlign === 'right' ? 'flex-end' : 'flex-start'
            }}
            aria-hidden="true"
          >
            <span className="dochub-sheet-hint__text">{hint}</span>
          </div>
        )}
        <input
          className="dochub-sheet-input has-date-icon"
          type={inputType === 'date' ? 'date' : 'datetime-local'}
          value={displayValue}
          readOnly
          disabled={disabled}
          title={tooltip}
          aria-label={hint}
          style={{ textAlign, cursor: disabled ? 'default' : 'pointer' }}
          onClick={openModal}
          onMouseDown={e => e.stopPropagation()}
        />
        <span className="dochub-sheet-date-icon" aria-hidden="true">
          <Calendar3 size={12} />
        </span>
      </div>

      <MilestoneDateModal
        show={open}
        config={config}
        milestone={milestone}
        buyerEmail={buyerEmail}
        appChoices={appChoices}
        onHide={closeModal}
        onSave={next => {
          if (onChange) onChange(next);
        }}
      />
    </div>
  );
};

export default MilestoneDateCell;
